import { Model } from 'pinia-orm';
import Interim from "./Interim";

export default class InterimAttachment extends Model {

    static get entity () {
        return 'interim-attachments';
    }

    static fields () {
        return {
            id: this.uid(() => null),
            interim_id: this.attr(''),
            title: this.string(''),
            filename: this.string(null),
            original_name: this.string(null),
            extension: this.string(null),
            url: this.string(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),

            // Relationship
            interim: this.belongsTo(Interim, 'interim_id')
        }
    }
}
